angular.module("vgresiduos").controller("MasterUserListCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/usuarios`);
		};
	}
]);
